import {ReactElement, useContext, useEffect} from "react";
import {AuthContext} from "../../contexts/AuthContext";
import {useRoutingUtils} from "../../routes/RoutingUtils";
import {LogInLogOutLoader} from "./LogInLogOutLoader";
import {ReactComponent as GlobeFill} from "@zendeskgarden/svg-icons/src/16/globe-fill.svg";

export function LoginCallback(): ReactElement {
    const authContext = useContext(AuthContext);
    const {goto} = useRoutingUtils();

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    useEffect(() => {
        if(code) {
            authContext.signInWithCallback(code)
                .then(() => goto("/"))
                .catch(err => console.error(err));
        }
    }, [code]);

    return <LogInLogOutLoader text="Logging In" image={<GlobeFill height="32px" width="32px" />} />;
}